<template> 
  <base-layout>
    <ul class="nav navbar-nav navbar-left" slot="toolbar_buttons">
      <li>
        <date-range-picker :datesRange="datesRange" @dates-range-updated="updatedDates"></date-range-picker>
      </li>
    </ul>
    <!-- slot main -->
    <div id="dashboard-canvas" class="col-xs-12 main with-leads-table with-leads-table-active" slot="main">
      <!-- components -->
      <div class="row ls-charts">
          <h1>Clients</h1>
          <div class="pivots-wrapper">
              <span class="pivot label" v-if="pivot_branch_options.length">
                  Branch:
                        <select v-model="pivots.branch_code">
                            <option :value="null"> - none - </option>
                            <option v-for="p in pivot_branch_options" :value="p[0]">{{ p[1] }}</option>
                        </select>
              </span>
              <span class="pivot label" v-if="pivot_type_options.length">
                  Policy Type:
                        <select v-model="pivots.policy_type_code">
                            <option :value="null"> - none - </option>
                            <option v-for="p in pivot_type_options" :value="p[0]">{{ p[1] }}</option>
                        </select>
              </span>
          </div>
        <div class="row">
        <div class="col-xs-12 col-lg-6">
          <div class="box">
            <div class="panel">
              <div class="panel-header">
                <h3>Clients by Branch</h3>
              </div>
              <div class="panel-body">
                <div class="col-xs-12 chart-wrapper">
                  <ls-chart target-css-classes="chart" 
                            :target-id="'by_branch'"
                            v-bind:bc-data="stats.chart_by_branch.series" 
                            v-bind:bc-layout="stats.chart_by_branch.layout">
                  </ls-chart>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-lg-6">
          <div class="box">
            <div class="panel">
              <div class="panel-header">
                <h3>Clients by Type</h3>
              </div>
              <div class="panel-body">
                <div class="col-xs-12 chart-wrapper">
                  <ls-chart target-css-classes="chart" 
                            :target-id="'by_type'"
                            v-bind:bc-data="stats.chart_by_type.series" 
                            v-bind:bc-layout="stats.chart_by_type.layout">
                  </ls-chart>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xs-12">
          <div class="box">
            <div class="panel">
              <epic-clients-table v-bind:pivots="pivots" v-bind:datesRange="datesRange" @loaded="refreshData"></epic-clients-table>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
    
    <div slot="modals">
      
    </div>
  </base-layout>
</template>

<script>
 /**
  * https://github.com/jbaysolutions/vue-grid-layout
  */
 import Vue from 'vue';

 import {BaseLayout} from 'components/layouts/';
 import DateRangePicker from 'components/elements/DateRangePicker';
 import EpicClientsTable from 'components/elements/EpicClientsTable';
 import LsChart from 'components/elements/PlotlyJS/LSBasicChart';
 import LsStatsTable from 'components/elements/LsStatsTable';

 // Load the full build. 
 var _ = require('lodash');

 export default {
   components: {
     BaseLayout,
     LsChart,
     DateRangePicker,
     EpicClientsTable,
     LsStatsTable
   },
   data () {
       return {
           pivot_branch_options: [],
           pivot_type_options: [],
           stats: {
               by_branch: [],
               by_type: [],
               chart_by_branch: {
                   series: [],
                   layout: {}
                   
               },
               chart_by_type: {
                   series: [],
                   layout: {}
                                  
               }
           },
           pivots: {
               branch_code: null,
               policy_type_code: null
           },
           datesRange: {
               from: null,
               to: null,
               date_field: null
           },
           pagination: {
	       current_page: 1, // required
           }
       };
   },
   
   computed: {

   },
   watch: {
   
   },
   created () {
     var u = this.$state.state.user;
   }, 
   methods: {
     refreshData(data) {
         this.stats = data.stats;
         this.pivot_branch_options = data.pivots.branch_code;
         this.pivot_type_options = data.pivots.policy_type_code;
     },
     updatedDates: _.debounce(function (datesRange) {
       this.datesRange = datesRange;
//       Vue.set(this, 'datesRange', datesRange);
     }),
   }
 }
</script>

<style lang="scss" scoped>
 .dashboard-header {
   color: #ddd;
   border-bottom: 1px solid #ddd;
   margin-bottom: 4px;
   padding: 0px;
 }
 .dashboard-header .btn-group {
   display: inline-block;
   margin-top: 3px;
 }
 3.dashboard-header .col-xs-10,
 .dashboard-header .col-xs-2 {
   padding-left: 3px;
   padding-right: 3px;
 }
 .dashboard-header h3 {
   color: #ddd;
   font-size: 14pt;
 }
 .dashboard-header .btn-default {
   color: #ddd!important;
   border: 0px;
   border-radius: 0px;
   background: transparent;
 }
 .dashboard-header .btn-default:hover,
 .dashboard-header .btn-default:focus,
 .dashboard-header .btn-default:active {
   border: 0px;
   background: #aeaeae;
   shadow-box: 0;
   color: #555!important;
 }

 .empty-msg {
   margin: 30px auto;
 }


 /* Leads Queue styles */
 h1 .btn {
   background-color: transparent;
   margin-top: -8px;
 }

 h1 input {
   background: #fff;
   border: 0px!important;
   padding: 0px;
   padding-top: 4px;
   margin-top: -4px;
 }

 .leads-queue {
   padding: 0px!important;
   border: 1px solid #999;
   border-bottom: 0px;
   margin: 0px!important;
   float: none;
 }

 .leads-queue .chart-wrapper {
   padding: 0px!important;
   height: 100%!important;
 }

 .endeless-table-container {
   padding: 10px;
 }

 .leads-queue-wrapper {
   padding: 0px;
   position: absolute;
   height: 100%;
 }

 .leads-queue.full-height {
   position: absolute;
   height: 100%;
   width: 100%;
 }

 #dashboard-canvas {
   display: flex;
   flex-direction: column;
 }

 .ls-charts {
   flex: 100vh;
   flex-grow: 1;
   width: 100%;
   overflow: hidden;
   position: relative;
   margin: 0px!important;

   .chart-wrapper {
     height: 40vh;
     margin: 0;
   }
 }

 .ls-leads-table {
   display: flex;
   padding: 0px;
   position: relative;
   margin: 0px!important;
 }

 .with-leads-table .ls-charts {
   height: calc(100vh - 112px);
 }

 .with-leads-table.with-leads-table-active .ls-charts {
   height: 100%;
   flex-grow: 1;
   flex-basis: 35%;
   padding-bottom: 20px;
 }

 .with-leads-table.with-leads-table-active .ls-leads-table {
   height: 100%;
   flex-grow: 1;
   flex-basis: 65%;
 }

 .ls-charts-wrapper {
   position: absolute;
   height: calc(100% - 60px);
   overflow-y: auto;
   padding-bottom: 200px;
 }

 .ls-charts h1 {
   margin-left: 10px;
   margin-right: 10px;
 }

 .ls-charts > h4 {
   margin-top: -20px;
   margin-left: 30px;
   margin-right: 30px;
   padding: 5px 10px;
   background-color: #f5f5f5;
   border: #e3e3e3;
   border-radius: 0px 0px 4px 4px;
 }

 #dashboard-canvas h1 form {
   display: inline-block;
   width: 100%;
   height: 20px;
 }

 #dashboard-canvas h1 input[type="text"] {
   background-color: #efefef;
   display: inline-block;
   width: 90%;
 }

 .vue-grid-placeholder {
   background-color: #333!important;
   border-radius: 4px 4px 4px 4px;
 }

 .metrics-banner-text {
   font-size: 1.8em;
   font-weight: 600;
   color: #ff7a7c;
 }

 .ls-charts > .row {
   margin: 0px;
 }

 .box {

   padding: 10px;
 }

</style>



// WEBPACK FOOTER //
// EpicClients.vue?eef7e538